<template>
    <el-date-picker
            popper-class="j-date-range-popper-wrap"
            :type="type"
            v-model="timeRange"
            v-bind="$attrs"
            v-on="$listeners"
            :clearable="clearable"
            :value-format="valueFormat"
            :range-separator="rangeSeparator"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endPlaceholder"
            @change="dateChange"
            :picker-options="pickerOptions"
    />
</template>

<script>
import moment from "moment";
export default {
  name: 'JDateRange',
  props: {
    type: { // ['datetimerange','daterange','monthrange']
       type: String,
       default: 'daterange'
    },
    beforeShortcuts: { // [7,30,90]
      type: Array,
      default: () => []
    },
    afterShortcuts: { // [7,30,90]
      type: Array,
      default: () => []
    },
    disabledRange: { // ['', 'before', 'after', 'before-today', 'after-today']
      type: String,
      default: ''
    },
    disabledDate: { // 禁用一个具体日期配合disabledRange使用
      type: String,
      default: ''
    },
    value: {
      type: [String, Array],
      default: ''
    },
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    },
    valueFormat: { // 'yyyy-MM-dd HH:mm:ss'
      type: String,
      default: 'yyyy-MM-dd'
    },
    rangeSeparator: {
      type: String,
      default: '至'
    },
    separator: { // 字段分割解析分隔符默认为逗号
      type: String,
      default: ','
    },
    startPlaceholder: {
      type: String,
      default: '开始日期'
    },
    endPlaceholder: {
      type: String,
      default: '结束日期'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      timeRange: [],
      pickerOptions: {
        shortcuts: null,
        disabledDate: null
      }
    }
  },
  created () {
    if (this.value && typeof this.value === 'string') {
        this.timeRange = this.value.split(this.separator)
    }
    if (this.start && this.end) {
      this.timeRange = [this.start, this.end]
    }
    this.updateDisabledRange(this.disabledRange) // 时间段限制
    // 快捷时间
    this.shortcutBeforeTime()
    this.shortcutAfterTime()
  },
  methods: {
    updateDisabledRange (disabledRange) {
      if (disabledRange === 'before') this.pickerOptions['disabledDate'] = this.disableBefore
      else if (disabledRange === 'after') this.pickerOptions['disabledDate'] = this.disableAfter
      else if (disabledRange === 'before-today') this.pickerOptions['disabledDate'] = this.disableBeforeToday
      else if (disabledRange === 'after-today') this.pickerOptions['disabledDate'] = this.disableAfterToday
      else this.pickerOptions['disabledDate'] = null
    },
    shortcutBeforeTime () {
        if (this.beforeShortcuts.length < 1) return
        if (!this.pickerOptions.shortcuts) this.pickerOptions.shortcuts = []
        if (this.type === 'monthrange') {
            this.beforeShortcuts.forEach(month => {
                this.pickerOptions.shortcuts.push({
                    text: `过去${month}个月`,
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - month);
                        picker.$emit('pick', [start, end]);
                    }
                })
            })
        } else {
            this.beforeShortcuts.forEach(day => {
                this.pickerOptions.shortcuts.push({
                    text: `最近${day}天`,
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * Number(day || 1))
                        picker.$emit('pick', [start, end])
                    }
                })
            })
        }
    },
    shortcutAfterTime () {
        if (this.afterShortcuts.length < 1) return
        if (!this.pickerOptions.shortcuts) this.pickerOptions.shortcuts = []
        if (this.type === 'monthrange') {
            this.afterShortcuts.forEach(month => {
                this.pickerOptions.shortcuts.push({
                    text: `未来${month}个月`,
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        end.setMonth(start.getMonth() + month);
                        picker.$emit('pick', [start, end]);
                    }
                })
            })
        } else {
            this.afterShortcuts.forEach(day => {
                this.pickerOptions.shortcuts.push({
                    text: `未来${day}天`,
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * Number(day || 1))
                        picker.$emit('pick', [start, end])
                    }
                })
            })
        }
    },
    disableBefore (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() < (date - 24 * 60 * 60 * 1000)
    },
    disableAfter (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() > date
    },
    disableBeforeToday (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() < date
    },
    disableAfterToday (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() > (date - 24 * 60 * 60 * 1000)
    },
    dateChange (v) {
      if (!v) {
        this.$emit('input', '')
        this.$emit('update:start', '')
        this.$emit('update:end', '')
        return
      }
      let start = v[0]
      let end = v[1]
      this.$emit('update:start', start)
      if (this.type === 'daterange' && end.includes('00:00:00')) end = end.substr(0, 10) + ' 23:59:59'
      this.$emit('update:end', end)
      this.$emit('input', `${start}${this.separator}${end}`)
    }
  },
  watch: {
    disabledDate () {
      this.updateDisabledRange(this.disabledRange)
    },
    disabledRange (nv) {
      this.updateDisabledRange(nv)
    },
    value (nv) {
      if (!nv) {
        this.timeRange = []
      } else if (typeof nv === 'string') {
        this.timeRange = nv.split(this.separator)
      }
    },
    start (nv) {
      this.timeRange = [nv || '', this.end || '']
    },
    end (nv) {
      this.timeRange = [this.start || '', nv || '']
    }
  }
}
</script>

<style lang="scss">
    .j-date-range-popper-wrap { // 时间范围时修正滚动条显示问题
        .el-time-spinner__wrapper {
            overflow: hidden;
        }
    }
</style>
